import { Component, Input } from '@angular/core';
import { DashboardLeaderboardMenuItem } from '../../dashboard.component';
import { GlobalLeaderboardBaseRow, OrgLeaderboardNewVideosRow, OrgLeaderboardTesRow, OrgLeaderboardViewRow } from '../leaderboard-api-response.model';
import { LeaderboardService } from '../leaderboard.service';
import { AppAnalyticsService } from 'src/app-analytics.service';

@Component({
    selector: 'app-org-leaderboard',
    templateUrl: './org-leaderboard.component.html',
    styleUrls: ['./org-leaderboard.component.scss'],
    standalone: false
})
export class OrgLeaderboardComponent {

  _dashboardLbType: DashboardLeaderboardMenuItem = 'views';
  @Input() 
  set dashboardLbType(value: DashboardLeaderboardMenuItem) {
    this._dashboardLbType = value;
    this.getCurrentLbData();
  }
  get dashboardLbType(): DashboardLeaderboardMenuItem {
    return this._dashboardLbType;
  }

  @Input()
  InitialData: OrgLeaderboardViewRow[] | OrgLeaderboardNewVideosRow[] | OrgLeaderboardTesRow[] | undefined = [];

  showHowToLink: boolean = false;
  isLoading: boolean = false;
  displayData: OrgLeaderboardViewRow[] | OrgLeaderboardNewVideosRow[] | OrgLeaderboardTesRow[] = [];

  constructor(private lbService: LeaderboardService, private analyticService: AppAnalyticsService) {  
  }

  ngOnInit(): void {
    if(!this.InitialData || this.InitialData.length == 0) {
      this.getCurrentLbData();
    }    
  }

  async getCurrentLbData() {
    this.isLoading = true;

    try {
      if (this.dashboardLbType == 'views') {
        this.displayData = await this.lbService.getOrgViewsLeaderboard();  
      } else if (this.dashboardLbType == 'videos') {
        this.displayData = await this.lbService.getOrgNewVideoLeaderboard();
      } else if (this.dashboardLbType == 'tes') {
        this.displayData = await this.lbService.getOrgTesLeaderboard();
      }  

      const user_records = (this.displayData as GlobalLeaderboardBaseRow[]).filter(d => d.user_id != null);
      this.showHowToLink = user_records.length == 0;
      
    } catch (error) {
      console.error(error);
    }
    
    this.isLoading = false;
  }

  didClickHowTo() {
    this.analyticService.log('dahsboard_leaderboard_how_to_button');
  }

}
